<template>
  <section id="feedback-form">
    <p>OK, if you would like to add any additional information you can do so below, or otherwise just click to submit your feedback</p>
    <EmailFormInput />
    <SubmitButton btnText="Send Feedback" />
  </section>
</template>

<script>
import EmailFormInput from '../components/EmailFormInput'
import SubmitButton from '../components/SubmitButton'

export default {
  components: {
    EmailFormInput,
    SubmitButton
  }
}
</script>


// WEBPACK FOOTER //
// src/components/FeedbackForm.vue